import { useEffect, useState } from "react";
import card1 from "../assets/hero1.jpg";
import card2 from "../assets/hero2.jpg";

const images = [
  card1 , card2
];

const Hero = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative  h-[60vh] overflow-hidden">
      
      {/* SLIDES */}
      <div
        className="flex h-full bg-[#fff9e6] transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((img, index) => (
          <div key={index} className="min-w-full h-full">
            <img
              src={img}
              alt="hero slide"
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-black/40" />

      {/* TEXT OVERLAY */}
      <div className="absolute inset-0 flex items-center justify-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white text-center px-6">
          Discover & Share Amazing Recipes 🍽️
        </h2>
      </div>

    </section>
  );
};

export default Hero;
